var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("notifications-page", {
    ref: "notifications",
    attrs: {
      loading: _vm.loading,
      "notification-preferences": _vm.notificationPreferences,
      "hide-all-web": "",
      source: "client",
    },
    on: { "allow-save": _vm.handleAllowSave, submit: _vm.handleSubmit },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }